/** 库内鉴别类型：3=仅外观 */
export const INSPECTION_TYPE_APPEARANCE_ONLY = 3;

/** 筛选项：外观+液体（对应库内 1 液体、2 寄售） */
export const INSPECTION_TYPE_FILTER_APPEARANCE_LIQUID = "appearance_liquid";

export const PLATFORM_INSPECTION_TYPE_FILTER_OPTIONS = [
  { value: INSPECTION_TYPE_APPEARANCE_ONLY, label: "外观" },
  { value: INSPECTION_TYPE_FILTER_APPEARANCE_LIQUID, label: "外观+液体鉴别" },
];

/** 列表/详情展示：仅「外观」或「外观+液体鉴别」 */
export function platformInspectionTypeLabel(type) {
  const t = Number(type);
  if (t === INSPECTION_TYPE_APPEARANCE_ONLY) return "外观";
  if (t === 1 || t === 2) return "外观+液体鉴别";
  return "-";
}

/** 列表查询参数：鉴别类型筛选 */
export function buildInspectionTypeListParams(filterValue) {
  if (filterValue == null || filterValue === "") {
    return {};
  }
  if (filterValue === INSPECTION_TYPE_FILTER_APPEARANCE_LIQUID) {
    return { inspectionType: null, inspectionTypeIn: [1, 2] };
  }
  return { inspectionType: filterValue, inspectionTypeIn: null };
}



// WEBPACK FOOTER //
// ./src/util/platformInspectionType.js